import { createSelector } from 'reselect';
import { showSelector } from 'selectors/testTarget/offers/horizontalSizeSelector/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showHorizontalSizeSelectorSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showHorizontalSizeSelectorSelector };
